module.exports = __webpack_public_path__ + "img/symbol_0.7aae9ae4.png";